import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function Careers() {
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>Careers at ClubLoop</h1>
          <p>
            Join us in building India's premier dedicated marketplace for pre-owned golf equipment.
            We are looking for passionate individuals who want to help golfers upgrade their game for less.
          </p>
        </div>

        <div className="infoSection">
          <h2>Why Join ClubLoop</h2>
          <p>
            We offer a dynamic, modern environment where you can work on circular-economy products
            that bring accessibility, trust, and standardized grading to the Indian golf community.
          </p>
          <div className="infoGrid">
            <div className="infoCard">
              <h3>Growth</h3>
              <p>Learn from marketplace innovators and drive growth inside a rapidly expanding sports tech domain.</p>
            </div>
            <div className="infoCard">
              <h3>Impact</h3>
              <p>Your work directly impacts individual players and courses by keeping premium gear in play longer.</p>
            </div>
            <div className="infoCard">
              <h3>Trust</h3>
              <p>Help optimize peer-to-peer verification, multi-point grading systems, and payment protections.</p>
            </div>
          </div>
        </div>

        <div className="infoSection">
          <h2>Job Categories</h2>
          <p>
            We look for talented professionals across engineering, operations, inspection, and customer experience.
          </p>
          <ul>
            <li>Engineering & Core Platform Development</li>
            <li>Product Management & Design (Mobile-First UI)</li>
            <li>Golf Equipment Valuation & Quality Grading Specialists</li>
            <li>Growth Marketing & Community Relations</li>
            <li>Escrow Operations & Customer Support</li>
          </ul>
        </div>

        <div className="infoSection">
          <h2>Open Positions</h2>
          <p>
            Check back soon for active roles, or send your portfolio and resume directly to
            our platform team.
          </p>
          <p>
            We are always excited to connect with developers, designers, and golf enthusiasts. Even if there
            isn't an immediate structural match today, we would love to hear from you.
          </p>
        </div>

        <div className="infoSection">
          <h2>Benefits</h2>
          <ul>
            <li>Competitive salary packages</li>
            <li>Health and comprehensive wellness programs</li>
            <li>Flexible, modern work arrangements</li>
            <li>Skill development, industry training, and learning budgets</li>
            <li>Team outings and golf community network access</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Careers;
